import { ca } from '@cian/analytics';
import { TDevice } from '@cian/utils';
import { TAnswersState } from '../../containers/FormContainer/types/internal';
import { getType } from './utils';
import { filter } from 'ramda';
import { getBannerSource } from '../getBannerSource';

export interface ITrackFormBaseEventProps {
  field: string;
  answersState: TAnswersState;
  deviceType: TDevice;
  anonymousUserId: string | null;
}

export interface ITrackFormEventProps extends ITrackFormBaseEventProps {
  action: string;
  label: string;
}
export const trackEvent = (props: ITrackFormEventProps) => {
  const { action, answersState, field, deviceType, label, anonymousUserId } = props;
  const type = getType(answersState, field);

  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action,
    label,
    page: {
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
      pageType: 'application_form',
      reviewsQty: anonymousUserId,
      extra: {
        type,
        banner_location: getBannerSource(),
      },
    },
  });
};

export const trackPrevStepEvent = ({ answersState, field, deviceType, anonymousUserId }: ITrackFormBaseEventProps) => {
  trackEvent({
    label: 'previous',
    action: 'Click',
    deviceType,
    field,
    answersState,
    anonymousUserId,
  });
};

export const trackBackToPageEvent = ({
  answersState,
  field,
  deviceType,
  anonymousUserId,
}: ITrackFormBaseEventProps) => {
  trackEvent({
    label: 'back_to_source',
    action: 'Click',
    deviceType,
    field,
    answersState,
    anonymousUserId,
  });
};

export interface ITrackClickEventProps extends ITrackFormBaseEventProps {
  isRequired: boolean;
  isDirty: boolean;
  value: string | null | undefined;
}

export const trackClickEvent = (props: ITrackClickEventProps) => {
  const { deviceType, field, answersState, isDirty, isRequired, value, anonymousUserId } = props;
  const requireLabel = isRequired ? 'isRequired' : 'notRequired';
  const defaultLabel = isDirty ? '' : 'default';
  const valueLabel = value ? value : '';

  trackEvent({
    label: filter(value => !!value, [requireLabel, defaultLabel, valueLabel]).join('/'),
    action: `Click_${field}`,
    deviceType,
    field,
    answersState,
    anonymousUserId,
  });
};

export const trackAddressFailEvent = ({
  answersState,
  field,
  deviceType,
  anonymousUserId,
}: ITrackFormBaseEventProps) => {
  trackEvent({
    label: '',
    action: 'fail',
    deviceType,
    field,
    answersState,
    anonymousUserId,
  });
};

export const trackCompleteButtonEvent = ({
  answersState,
  field,
  deviceType,
  anonymousUserId,
}: ITrackFormBaseEventProps) => {
  trackEvent({
    label: 'back_to_source',
    action: 'Click',
    deviceType,
    field,
    answersState,
    anonymousUserId,
  });
};

export const trackFormSend = ({ answersState, field, deviceType, anonymousUserId }: ITrackFormBaseEventProps) => {
  trackEvent({
    label: 'Page',
    action: 'Send',
    deviceType,
    field,
    answersState,
    anonymousUserId,
  });
};
